import { dimensions } from '../mixinProps'

/**
 * vc-graphics-box base props mixins
 */
export default {
  mixins: [dimensions]
}
